(function () {

  'use strict';

  angular.module('eclipseApp.myAccount').controller('selfServeModemCtrl', ['$rootScope', '$scope', '$translate', '$modalInstance', '$q', '$state', '$http', 'uteModal', 'uteEndpoint', 'notifierService', 'commonService', 'action', 'orderId', function ($rootScope, $scope, $translate, $modalInstance, $q, $state, $http, uteModal, uteEndpoint, notifierService, commonService, action, orderId) {
    var actionContext = action;
    var targetEndpoint;

    var apis = {
      //modemReturnEndpoint: 'http://localhost:8888/resource/returnModem.json',
      //modemPickUpEndpoint: 'http://localhost:8888/resource/pickupModem.json',
      //modemExchangeEndpoint: 'http://localhost:8888/resource/exchangeModem.json',

      modemReturnEndpoint: uteEndpoint('v1/returnModem'),
      modemPickUpEndpoint: uteEndpoint('v1/pickupModem'),
      modemExchangeEndpoint: uteEndpoint('v1/hardwareexchange')
    };

    $scope.accountDetails = commonService.accountDetails;

    console.log('action:', actionContext);

    $scope.modemSerialValidationRules = {
      equipmentSerialNumber: {pattern: '([a-zA-Z0-9]{1,50})'},
      newSerial: {pattern: '([a-zA-Z0-9]{1,50})'}
    };

    $scope.modemInfo = {};
    $scope.modemInfo.successfullyReturnedModem = false;
    $scope.modemInfo.successfullyPickedUpModem = false;
    $scope.modemInfo.successfullyExchangedModem = false;
    $scope.checkSerialState = checkSerialState;
    $scope.init = initFromAction;

    $scope.init();

    var modemData = {};


    $scope.completeOrder = function () {

      $scope.modemForm.equipmentSerialNumber.$setDirty();

      if ($scope.isModemExchange) {
        if (($scope.modemForm.equipmentSerialNumber && $scope.modemForm.equipmentSerialNumber.$invalid) || ($scope.modemForm.newSerial && $scope.modemForm.newSerial.$invalid)) {
          console.log('completeOrder: serials invalid');
          return;
        }
      }
      else {
        if ($scope.modemForm.equipmentSerialNumber && $scope.modemForm.equipmentSerialNumber.$invalid) {
          console.log('completeOrder: serials invalid');
          return;
        }
      }

      var data = _.pick($scope.modemInfo, ['equipmentSerialNumber', 'newSerial']);
      var request = data;
      request.orderId = orderId;

      if ($scope.isModemExchange) {
        request.existingSerial = request.equipmentSerialNumber;
        delete request.equipmentSerialNumber;
      }

      //Reset errors
      $scope.error60000 = false;
      $scope.error60001 = false;

      sendEquipmentRequest(targetEndpoint, request).then(function (res) {
        if (res.error==='60000') {
          $scope.error60000 = true;
        }
        else if (res.error==='60001') {
          $scope.error60001 = true;
        }
        else if (res.error==='30002') {
          $scope.error30002 = true;
        }
        else if (res.error==='30001') {
          $scope.error30001 = true;
        }
        else if (res.status === 'FAILURE'){
          notifierService.error('50000');
        }
        else {
          if (actionContext === 'return-modem') {
            $scope.modemInfo.successfullyReturnedModem = true;
          } else if (actionContext === 'pickup-modem') {
            $scope.modemInfo.successfullyPickedUpModem = true;
          } else if (actionContext === 'exchange-modem') {
            $scope.modemInfo.successfullyExchangedModem = true;
          }
          //prepare data for printReceipt
          modemData.status = res.status;
          modemData.workOrderNo = res.orderID;
          modemData.action = actionContext;
          if ($scope.isModemExchange){
            modemData.returnModemSerial = res.returnModemSerial;
            modemData.pickUpModemSerial = res.pickUpModemSerial;
          }
          else {
            modemData.equipmentId = res.equipmentSerialNumber;
          };

          //Todo: Get data from server, currently hard coded
          $translate('global.label.modemRentalName').then(function (homeGateway) {
            modemData.details = homeGateway;
          });

          var tentativeAcct = _.findKey($rootScope.userInfo.accounts, {status:'TENTATIVE'});

          if (tentativeAcct !== undefined) {
            $rootScope.userInfo.accounts[tentativeAcct].status = 'OPEN';
          }

          //Reload the customer information as account status has changed
          commonService.getAccountDetails($rootScope.userInfo.accounts, true);

          console.log('Modem Data in selfServerModemCtrl :', modemData);
        }
      }, function(resp) {
        notifierService.error(resp.error);
      });
    };

    $scope.shouldDisplayConfirmationMessage = function () {
      return $scope.modemInfo && ($scope.modemInfo.successfullyExchangedModem || $scope.modemInfo.successfullyReturnedModem || $scope.modemInfo.successfullyPickedUpModem);
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    $scope.clearSerial = function () {
      $scope.modemInfo.equipmentSerialNumber = null;
      $scope.modemInfo.newSerial = null;
      $scope.modemForm.$setPristine();
      if($scope.modemForm.equipmentSerialNumber){
        $scope.modemForm.equipmentSerialNumber.$setPristine();
      }
      if($scope.modemForm.newSerial){
        $scope.modemForm.newSerial.$setPristine();
      }
      $scope.error60000 = false;
      $scope.error60001 = false;
      $scope.error30001 = false;
      $scope.error30002 = false;

      //Close dialog for exchange-modem
      if (actionContext === 'exchange-modem') {
        $scope.cancel();
      }
    };

    $scope.equipmentConfirmed = function () {
      return $scope.modemInfo.successfullyPickedUpModem || $scope.modemInfo.successfullyReturnedModem || $scope.modemInfo.successfullyExchangedModem;
    };


    function checkSerialState() {
      if (!$scope.modemInfo.equipmentSerialNumber) {
        if (angular.isDefined($scope.modemInfo.successfullyReturnedModem)) {
          $scope.modemInfo.successfullyReturnedModem = false;
        }

        if (angular.isDefined($scope.modemInfo.successfullyPickedUpModem)) {
          $scope.modemInfo.successfullyPickedUpModem = false;
        }

        if (angular.isDefined($scope.modemInfo.successfullyExchangedModem)) {
          $scope.modemInfo.successfullyExchangedModem = false;
        }
      }

      if ($scope.isModemExchange) {
        if ($scope.modemInfo.newSerial === $scope.modemInfo.equipmentSerialNumber && $scope.modemInfo.newSerial !== "" && $scope.modemInfo.newSerial !== undefined)
        {
          $scope.modemForm.newSerial.$setValidity('match', false);
          return;
        }
        $scope.modemForm.newSerial.$setValidity('match', true);
      }
    }

    $scope.printReceipt = function(){
      $state.go('modemReceipt',
        {'status': modemData.status,
          'workOrderNo': modemData.workOrderNo,
          'equipmentId': modemData.equipmentId || '',
          'details': modemData.details,
          'action': modemData.action,
          'returnModemSerial': modemData.returnModemSerial || '',
          'pickUpModemSerial': modemData.pickUpModemSerial || ''
        });
    };

    function clearRequestState() {
      $scope.modemInfo.successfullyReturnedModem = false;
      $scope.modemInfo.successfullyPickedUpModem = false;
      $scope.modemInfo.successfullyExchangedModem = false;
      $scope.error60000 = false;
      $scope.error60001 = false;
      $scope.error30001 = false;
      $scope.error30002 = false;
    }

    function sendEquipmentRequest(endpoint, request) {
      var deferred = $q.defer();

      notifierService.loading('start');

      console.log('Send Equipment Request accounts: ', $rootScope.userInfo.accounts);

      //Todo: Account number to be removed from the call
      var tentativeAcct = _.findKey($rootScope.userInfo.accounts, {status:'TENTATIVE'});

      if (tentativeAcct !== undefined && !$scope.isModemExchange) {
        if ($rootScope.userInfo && $rootScope.userInfo.accounts) {
          angular.extend(request, {accountNumber: $rootScope.userInfo.accounts[tentativeAcct].accountNumber});
        }
      }
      else {
        var internetAccount = null, internetAccountNumber;
        if ($rootScope.userInfo && $rootScope.userInfo.accounts) {
          internetAccount = _.find($rootScope.userInfo.accounts, function (account) {
            return account.serviceName.toLowerCase() === 'internet/tv';
          });

          if (internetAccount) {
            internetAccountNumber = internetAccount.accountNumber;
          }
          else {
            internetAccountNumber = 0;
          }

          angular.extend(request, {
            accountNumber: internetAccountNumber,
            subscriptionNumber: commonService.internetSubscriberNo
          });
        }
      }

      $http.post(endpoint, request)
        .success(function (res) {
          var error = (res.error!=='60000' && res.error!=='60001' && res.error!=='30002' && res.error!=='30001') ? res.error : false;
          if (!error) {
            deferred.resolve(res);
          } else {
            deferred.reject(res);
          }
          notifierService.loading('close');
        }).error(function (res) {
          clearRequestState();
          deferred.reject(res);
          notifierService.loading('close');
        });

      return deferred.promise;
    }

    function initFromAction() {
      var translations = [];

      translations.push({'global.label.modemSerialNumber': 'equipmentSerialLabel'});
      switch (actionContext) {
        case 'return-modem':
          targetEndpoint = apis.modemReturnEndpoint;
          translations.push({'global.label.modemReturn': 'title'});
          translations.push({'global.message.modemReturnConfirmation': 'confirmationMessage'});
          break;
        case 'pickup-modem':
          targetEndpoint = apis.modemPickUpEndpoint;
          translations.push({'global.label.modemPickUp': 'title'});
          translations.push({'global.message.modemPickUpConfirmation': 'confirmationMessage'});
          break;
        case 'exchange-modem':
          $scope.isModemExchange = true;
          targetEndpoint = apis.modemExchangeEndpoint;
          translations.push({'global.label.modemSerialNumberExchange': 'title'});
          translations.push({'global.label.modemSerialNumberOld': 'equipmentSerialLabel'});
          translations.push({'global.message.modemExchangeAcknowledgement': 'confirmationMessage'});
          break;
      }

      _.each(translations, function (obj) {
        var keys = _.keys(obj);

        $translate(keys[0]).then(function (translation) {
          $scope[obj[keys[0]]] = translation;
          // console.log(obj[keys[0]], '=> ', translation);
        });
      });
    }
  }]);

})();
